import { render } from "./RequestServiceButton.vue?vue&type=template&id=5b283710"
import script from "./RequestServiceButton.vue?vue&type=script&lang=js"
export * from "./RequestServiceButton.vue?vue&type=script&lang=js"

import "./RequestServiceButton.vue?vue&type=style&index=0&id=5b283710&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__